import React from 'react';

import { MenuItem } from '@material-ui/core';
import styled from 'styled-components';
import { FlexContainer } from 'styles/common';

import { QUESTION_FORM_SOURCES } from 'constants/ProjectConstants';
import theme from 'constants/theme';

import { Typography4 } from 'uiToolkit/Typography';

import CommentsCheckboxes from './commentsCheckboxes';
import { StyledSelect } from './styles';

const OPTIONS_COUNT = [3, 4, 5, 6, 7, 8, 9, 10];

const StarRatingAnswerType = ({ question, updateQuestion, source, isDuplicating }) => {
  const handleChange = (value) => {
    const answerOptions = Array.from({ length: value }).map((i, index) => ({
      description: '',
      displayOrder: index + 1,
      score: index + 1,
    }));
    updateQuestion('STAR_RATING', {
      maxOptions: value,
      answerOptions,
    });
  };
  const handleQuestionChange = (param, value) => updateQuestion(param, value);

  const isDisabled =
    !isDuplicating &&
    (source === QUESTION_FORM_SOURCES.ENGAGEMENT || source === QUESTION_FORM_SOURCES.REVIEW) &&
    question?.isEditable === false;

  return (
    <Container>
      {question && (
        <>
          <FlexContainer style={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography4 customColor={theme.palette.text.dark1} topGutter={1}>
              Max Value
            </Typography4>
            <StyledSelect
              value={question.answerOptions.length}
              displayEmpty
              variant="outlined"
              onChange={(e) => handleChange(e.target.value)}
              width="45%"
              disabled={isDisabled}
            >
              {OPTIONS_COUNT.map((emojiCount) => (
                <StyledMenuItem primary value={emojiCount}>
                  <Typography4>{emojiCount}</Typography4>
                </StyledMenuItem>
              ))}
            </StyledSelect>
          </FlexContainer>
          <CommentsCheckboxes
            question={question}
            handleQuestionChange={handleQuestionChange}
            source={source}
            isDuplicating={isDuplicating}
          />
        </>
      )}
    </Container>
  );
};

const Container = styled.div`
  margin-top: 1.5rem;
`;

const StyledMenuItem = styled(MenuItem)`
  padding-left: 24px;
  padding-right: 24px;
  &:hover {
    background: none;
    .MuiTouchRipple-root {
      background-color: rgba(0, 0, 0, 0.04);
    }
  }

  &.Mui-selected {
    background: none;
    &:hover {
      background: none;
    }
    .MuiTouchRipple-root {
      background-color: rgba(0, 0, 0, 0.08);
    }
  }
`;

export default StarRatingAnswerType;
